import React from 'react';

import { months } from 'constants/common';
import { Autocomplete } from 'components/FormFields';
import { handleShowError, handleError, generateFilterOptions } from 'utils';

const MonthSelect = ({
  label,
  variant = 'standard',
  field: { name = 'months', value },
  form: { errors, touched, setFieldValue = () => {} },
  omitFields = [],
  asyncErrors,
  margin = 'none',
}) => {
  const filterOptions = generateFilterOptions('start', 'label');

  return (
    <Autocomplete
      id={name}
      openOnFocus
      label={label}
      margin={margin}
      variant={variant}
      filterOptions={filterOptions}
      getOptionLabel={(option) => option?.label || ''}
      error={handleError(name, errors, touched, asyncErrors)}
      options={months.filter((val) => omitFields.indexOf(val))}
      getOptionSelected={(option, value) => option == value || ''}
      onChange={(ev, val) => setFieldValue(name, val?.value || '')}
      helperText={handleShowError(name, errors, touched, asyncErrors)}
      value={months.find((month) => month?.value == value) || ''}
    />
  );
};

export { MonthSelect };
